export default __webpack_public_path__ + "442e408.png";